import { useEffect, useState } from "react";
import { _Entailment } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import { AppointmentManualEditor } from "../AppointmentManual/AppointmentManual.editor";
import { AppointmentGroupManualEditor } from "../AppointmentGroupManual/AppointmentGroupManual.editor";
import { _EmployeeContractType } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { InputDate } from "../../../theme/Input/InputDate";


export const EmployeeContractType = () => {

    const employeecontract = useDataBean(_EmployeeContractType);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        employeecontract.instance.getEmployeeContractTypeCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        employeecontract.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        employeecontract.instance.deleteEmployeeContractType(employeecontract.bean.IDEmployeeContractType).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        employeecontract.instance.updateEmployeeContractType(employeecontract.bean).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDEmployeeContractType', visible: true },
        { title: 'Código', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Código Payroll Electrónico', property: 'ElectronicPayrollCode', visible: true },
        { title: 'Desde', property: 'Since', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${employeecontract.bean.Name}`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Tipos de Contrato Laboral">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={employeecontract.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-6">
                                <label>Código</label>
                                <input type="text" name="Code" className="form-control" value={employeecontract.bean.Code} onChange={employeecontract.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={employeecontract.bean.Name} onChange={employeecontract.handleChange} />

                            </div>
                            <div className="col-md-6">
                                <label>Código Payroll Electrónico</label>
                                <input type="text" name="ElectronicPayrollCode" className="form-control" value={employeecontract.bean.ElectronicPayrollCode} onChange={employeecontract.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <InputDate notDate label="Fecha Desde" name="Date" value={employeecontract.bean.Since} setDate={(e) => { employeecontract.setBean({ ...employeecontract.bean, "Since": e }) }} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {employeecontract.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}